import { genericApiToaster } from 'src/services/utils';
import { getTaggedTickets } from 'src/services/ticket.permissions.service';

export default async function filterByTab(
  perspective,
  tickets,
  userId,
  currentUserRole,
  departmentIds,
  setTicketsWithStatus,
  setFilterByData,
  showToast,
  hideToast,
  t
) {
  const safeTickets = Array.isArray(tickets) ? tickets : [];

  const tabFilters = {
    // TIER 1
    ALL_TICKETS: () => safeTickets,

    // TIER 2
    MY_TICKETS: () => safeTickets.filter((tk) => tk?.createdBy === userId),

    // TIER 3
    ASSIGNED_TO_ME: () => safeTickets.filter((tk) => tk?.assignedTo === userId),

    // TIER 4
    TAGGED_TICKETS: async () => {
      await genericApiToaster(
        getTaggedTickets,
        userId,
        '',
        t('errorMessages.couldntLoadTicket'),
        showToast,
        hideToast,
        t,
        (res) => {
          const tagged =
            (res || []).length > 0
              ? safeTickets.filter((tk) => res.some((rt) => rt.id === tk.id))
              : [];
          setTicketsWithStatus(tagged);
          setFilterByData(tagged);
        }
      );
    },
  };

  const filterFn = tabFilters[perspective] || tabFilters.ALL_TICKETS;
  const filteredResult = await filterFn();

  if (perspective !== 'TAGGED_TICKETS') {
    setTicketsWithStatus(filteredResult || []);
    setFilterByData(filteredResult || []);
  }
}
